// A curated list of countries with flag emojis
// You can expand this list or use a library like 'world-countries' for a full dataset

export const COUNTRIES = [
    { code: 'ZA', label: 'South Africa', flag: '🇿🇦' },
    { code: 'AF', label: 'Afghanistan', flag: '🇦🇫' },
    { code: 'AL', label: 'Albania', flag: '🇦🇱' },
    { code: 'DZ', label: 'Algeria', flag: '🇩🇿' },
    { code: 'AD', label: 'Andorra', flag: '🇦🇩' },
    { code: 'AO', label: 'Angola', flag: '🇦🇴' },
    { code: 'AG', label: 'Antigua and Barbuda', flag: '🇦🇬' },
    { code: 'AR', label: 'Argentina', flag: '🇦🇷' },
    { code: 'AM', label: 'Armenia', flag: '🇦🇲' },
    { code: 'AU', label: 'Australia', flag: '🇦🇺' },
    { code: 'AT', label: 'Austria', flag: '🇦🇹' },
    { code: 'AZ', label: 'Azerbaijan', flag: '🇦🇿' },
    { code: 'BS', label: 'Bahamas', flag: '🇧🇸' },
    { code: 'BH', label: 'Bahrain', flag: '🇧🇭' },
    { code: 'BD', label: 'Bangladesh', flag: '🇧🇩' },
    { code: 'BB', label: 'Barbados', flag: '🇧🇧' },
    { code: 'BY', label: 'Belarus', flag: '🇧🇾' },
    { code: 'BE', label: 'Belgium', flag: '🇧🇪' },
    { code: 'BZ', label: 'Belize', flag: '🇧🇿' },
    { code: 'BJ', label: 'Benin', flag: '🇧🇯' },
    { code: 'BT', label: 'Bhutan', flag: '🇧🇹' },
    { code: 'BO', label: 'Bolivia', flag: '🇧🇴' },
    { code: 'BA', label: 'Bosnia and Herzegovina', flag: '🇧🇦' },
    { code: 'BW', label: 'Botswana', flag: '🇧🇼' },
    { code: 'BR', label: 'Brazil', flag: '🇧🇷' },
    { code: 'BN', label: 'Brunei', flag: '🇧🇳' },
    { code: 'BG', label: 'Bulgaria', flag: '🇧🇬' },
    { code: 'BF', label: 'Burkina Faso', flag: '🇧🇫' },
    { code: 'BI', label: 'Burundi', flag: '🇧🇮' },
    { code: 'CV', label: 'Cabo Verde', flag: '🇨🇻' },
    { code: 'KH', label: 'Cambodia', flag: '🇰🇭' },
    { code: 'CM', label: 'Cameroon', flag: '🇨🇲' },
    { code: 'CA', label: 'Canada', flag: '🇨🇦' },
    { code: 'CF', label: 'Central African Republic', flag: '🇨🇫' },
    { code: 'TD', label: 'Chad', flag: '🇹🇩' },
    { code: 'CL', label: 'Chile', flag: '🇨🇱' },
    { code: 'CN', label: 'China', flag: '🇨🇳' },
    { code: 'CO', label: 'Colombia', flag: '🇨🇴' },
    { code: 'KM', label: 'Comoros', flag: '🇰🇲' },
    { code: 'CG', label: 'Congo (Congo-Brazzaville)', flag: '🇨🇬' },
    { code: 'CD', label: 'Congo (Democratic Republic)', flag: '🇨🇩' },
    { code: 'CR', label: 'Costa Rica', flag: '🇨🇷' },
    { code: 'CI', label: "Côte d'Ivoire", flag: '🇨🇮' },
    { code: 'HR', label: 'Croatia', flag: '🇭🇷' },
    { code: 'CU', label: 'Cuba', flag: '🇨🇺' },
    { code: 'CY', label: 'Cyprus', flag: '🇨🇾' },
    { code: 'CZ', label: 'Czechia', flag: '🇨🇿' },
    { code: 'DK', label: 'Denmark', flag: '🇩🇰' },
    { code: 'DJ', label: 'Djibouti', flag: '🇩🇯' },
    { code: 'DM', label: 'Dominica', flag: '🇩🇲' },
    { code: 'DO', label: 'Dominican Republic', flag: '🇩🇴' },
    { code: 'EC', label: 'Ecuador', flag: '🇪🇨' },
    { code: 'EG', label: 'Egypt', flag: '🇪🇬' },
    { code: 'SV', label: 'El Salvador', flag: '🇸🇻' },
    { code: 'GQ', label: 'Equatorial Guinea', flag: '🇬🇶' },
    { code: 'ER', label: 'Eritrea', flag: '🇪🇷' },
    { code: 'EE', label: 'Estonia', flag: '🇪🇪' },
    { code: 'SZ', label: 'Eswatini', flag: '🇸🇿' },
    { code: 'ET', label: 'Ethiopia', flag: '🇪🇹' },
    { code: 'FJ', label: 'Fiji', flag: '🇫🇯' },
    { code: 'FI', label: 'Finland', flag: '🇫🇮' },
    { code: 'FR', label: 'France', flag: '🇫🇷' },
    { code: 'GA', label: 'Gabon', flag: '🇬🇦' },
    { code: 'GM', label: 'Gambia', flag: '🇬🇲' },
    { code: 'GE', label: 'Georgia', flag: '🇬🇪' },
    { code: 'DE', label: 'Germany', flag: '🇩🇪' },
    { code: 'GH', label: 'Ghana', flag: '🇬🇭' },
    { code: 'GR', label: 'Greece', flag: '🇬🇷' },
    { code: 'GD', label: 'Grenada', flag: '🇬🇩' },
    { code: 'GT', label: 'Guatemala', flag: '🇬🇹' },
    { code: 'GN', label: 'Guinea', flag: '🇬🇳' },
    { code: 'GW', label: 'Guinea-Bissau', flag: '🇬🇼' },
    { code: 'GY', label: 'Guyana', flag: '🇬🇾' },
    { code: 'HT', label: 'Haiti', flag: '🇭🇹' },
    { code: 'VA', label: 'Holy See (Vatican City)', flag: '🇻🇦' },
    { code: 'HN', label: 'Honduras', flag: '🇭🇳' },
    { code: 'HU', label: 'Hungary', flag: '🇭🇺' },
    { code: 'IS', label: 'Iceland', flag: '🇮🇸' },
    { code: 'IN', label: 'India', flag: '🇮🇳' },
    { code: 'ID', label: 'Indonesia', flag: '🇮🇩' },
    { code: 'IR', label: 'Iran', flag: '🇮🇷' },
    { code: 'IQ', label: 'Iraq', flag: '🇮🇶' },
    { code: 'IE', label: 'Ireland', flag: '🇮🇪' },
    { code: 'IL', label: 'Israel', flag: '🇮🇱' },
    { code: 'IT', label: 'Italy', flag: '🇮🇹' },
    { code: 'JM', label: 'Jamaica', flag: '🇯🇲' },
    { code: 'JP', label: 'Japan', flag: '🇯🇵' },
    { code: 'JO', label: 'Jordan', flag: '🇯🇴' },
    { code: 'KZ', label: 'Kazakhstan', flag: '🇰🇿' },
    { code: 'KE', label: 'Kenya', flag: '🇰🇪' },
    { code: 'KI', label: 'Kiribati', flag: '🇰🇮' },
    { code: 'KP', label: 'Korea (North)', flag: '🇰🇵' },
    { code: 'KR', label: 'Korea (South)', flag: '🇰🇷' },
    { code: 'KW', label: 'Kuwait', flag: '🇰🇼' },
    { code: 'KG', label: 'Kyrgyzstan', flag: '🇰🇬' },
    { code: 'LA', label: 'Laos', flag: '🇱🇦' },
    { code: 'LV', label: 'Latvia', flag: '🇱🇻' },
    { code: 'LB', label: 'Lebanon', flag: '🇱🇧' },
    { code: 'LS', label: 'Lesotho', flag: '🇱🇸' },
    { code: 'LR', label: 'Liberia', flag: '🇱🇷' },
    { code: 'LY', label: 'Libya', flag: '🇱🇾' },
    { code: 'LI', label: 'Liechtenstein', flag: '🇱🇮' },
    { code: 'LT', label: 'Lithuania', flag: '🇱🇹' },
    { code: 'LU', label: 'Luxembourg', flag: '🇱🇺' },
    { code: 'MG', label: 'Madagascar', flag: '🇲🇬' },
    { code: 'MW', label: 'Malawi', flag: '🇲🇼' },
    { code: 'MY', label: 'Malaysia', flag: '🇲🇾' },
    { code: 'MV', label: 'Maldives', flag: '🇲🇻' },
    { code: 'ML', label: 'Mali', flag: '🇲🇱' },
    { code: 'MT', label: 'Malta', flag: '🇲🇹' },
    { code: 'MH', label: 'Marshall Islands', flag: '🇲🇭' },
    { code: 'MR', label: 'Mauritania', flag: '🇲🇷' },
    { code: 'MU', label: 'Mauritius', flag: '🇲🇺' },
    { code: 'MX', label: 'Mexico', flag: '🇲🇽' },
    { code: 'FM', label: 'Micronesia', flag: '🇫🇲' },
    { code: 'MD', label: 'Moldova', flag: '🇲🇩' },
    { code: 'MC', label: 'Monaco', flag: '🇲🇨' },
    { code: 'MN', label: 'Mongolia', flag: '🇲🇳' },
    { code: 'ME', label: 'Montenegro', flag: '🇲🇪' },
    { code: 'MA', label: 'Morocco', flag: '🇲🇦' },
    { code: 'MZ', label: 'Mozambique', flag: '🇲🇿' },
    { code: 'MM', label: 'Myanmar', flag: '🇲🇲' },
    { code: 'NA', label: 'Namibia', flag: '🇳🇦' },
    { code: 'NR', label: 'Nauru', flag: '🇳🇷' },
    { code: 'NP', label: 'Nepal', flag: '🇳🇵' },
    { code: 'NL', label: 'Netherlands', flag: '🇳🇱' },
    { code: 'NZ', label: 'New Zealand', flag: '🇳🇿' },
    { code: 'NI', label: 'Nicaragua', flag: '🇳🇮' },
    { code: 'NE', label: 'Niger', flag: '🇳🇪' },
    { code: 'NG', label: 'Nigeria', flag: '🇳🇬' },
    { code: 'MK', label: 'North Macedonia', flag: '🇲🇰' },
    { code: 'NO', label: 'Norway', flag: '🇳🇴' },
    { code: 'OM', label: 'Oman', flag: '🇴🇲' },
    { code: 'PK', label: 'Pakistan', flag: '🇵🇰' },
    { code: 'PW', label: 'Palau', flag: '🇵🇼' },
    { code: 'PS', label: 'Palestine', flag: '🇵🇸' },
    { code: 'PA', label: 'Panama', flag: '🇵🇦' },
    { code: 'PG', label: 'Papua New Guinea', flag: '🇵🇬' },
    { code: 'PY', label: 'Paraguay', flag: '🇵🇾' },
    { code: 'PE', label: 'Peru', flag: '🇵🇪' },
    { code: 'PH', label: 'Philippines', flag: '🇵🇭' },
    { code: 'PL', label: 'Poland', flag: '🇵🇱' },
    { code: 'PT', label: 'Portugal', flag: '🇵🇹' },
    { code: 'QA', label: 'Qatar', flag: '🇶🇦' },
    { code: 'RO', label: 'Romania', flag: '🇷🇴' },
    { code: 'RU', label: 'Russia', flag: '🇷🇺' },
    { code: 'RW', label: 'Rwanda', flag: '🇷🇼' },
    { code: 'KN', label: 'Saint Kitts and Nevis', flag: '🇰🇳' },
    { code: 'LC', label: 'Saint Lucia', flag: '🇱🇨' },
    { code: 'VC', label: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
    { code: 'WS', label: 'Samoa', flag: '🇼🇸' },
    { code: 'SM', label: 'San Marino', flag: '🇸🇲' },
    { code: 'ST', label: 'São Tomé and Príncipe', flag: '🇸🇹' },
    { code: 'SA', label: 'Saudi Arabia', flag: '🇸🇦' },
    { code: 'SN', label: 'Senegal', flag: '🇸🇳' },
    { code: 'RS', label: 'Serbia', flag: '🇷🇸' },
    { code: 'SC', label: 'Seychelles', flag: '🇸🇨' },
    { code: 'SL', label: 'Sierra Leone', flag: '🇸🇱' },
    { code: 'SG', label: 'Singapore', flag: '🇸🇬' },
    { code: 'SK', label: 'Slovakia', flag: '🇸🇰' },
    { code: 'SI', label: 'Slovenia', flag: '🇸🇮' },
    { code: 'SB', label: 'Solomon Islands', flag: '🇸🇧' },
    { code: 'SO', label: 'Somalia', flag: '🇸🇴' },
    { code: 'SS', label: 'South Sudan', flag: '🇸🇸' },
    { code: 'ES', label: 'Spain', flag: '🇪🇸' },
    { code: 'LK', label: 'Sri Lanka', flag: '🇱🇰' },
    { code: 'SD', label: 'Sudan', flag: '🇸🇩' },
    { code: 'SR', label: 'Suriname', flag: '🇸🇷' },
    { code: 'SE', label: 'Sweden', flag: '🇸🇪' },
    { code: 'CH', label: 'Switzerland', flag: '🇨🇭' },
    { code: 'SY', label: 'Syria', flag: '🇸🇾' },
    { code: 'TW', label: 'Taiwan', flag: '🇹🇼' },
    { code: 'TJ', label: 'Tajikistan', flag: '🇹🇯' },
    { code: 'TZ', label: 'Tanzania', flag: '🇹🇿' },
    { code: 'TH', label: 'Thailand', flag: '🇹🇭' },
    { code: 'TL', label: 'Timor-Leste', flag: '🇹🇱' },
    { code: 'TG', label: 'Togo', flag: '🇹🇬' },
    { code: 'TO', label: 'Tonga', flag: '🇹🇴' },
    { code: 'TT', label: 'Trinidad and Tobago', flag: '🇹🇹' },
    { code: 'TN', label: 'Tunisia', flag: '🇹🇳' },
    { code: 'TR', label: 'Türkiye', flag: '🇹🇷' },
    { code: 'TM', label: 'Turkmenistan', flag: '🇹🇲' },
    { code: 'TV', label: 'Tuvalu', flag: '🇹🇻' },
    { code: 'UG', label: 'Uganda', flag: '🇺🇬' },
    { code: 'UA', label: 'Ukraine', flag: '🇺🇦' },
    { code: 'AE', label: 'United Arab Emirates', flag: '🇦🇪' },
    { code: 'GB', label: 'United Kingdom', flag: '🇬🇧' },
    { code: 'US', label: 'United States', flag: '🇺🇸' },
    { code: 'UY', label: 'Uruguay', flag: '🇺🇾' },
    { code: 'UZ', label: 'Uzbekistan', flag: '🇺🇿' },
    { code: 'VU', label: 'Vanuatu', flag: '🇻🇺' },
    { code: 'VE', label: 'Venezuela', flag: '🇻🇪' },
    { code: 'VN', label: 'Vietnam', flag: '🇻🇳' },
    { code: 'YE', label: 'Yemen', flag: '🇾🇪' },
    { code: 'ZM', label: 'Zambia', flag: '🇿🇲' },
    { code: 'ZW', label: 'Zimbabwe', flag: '🇿🇼' },
    { code: 'OT', label: 'Other', flag: '🌍' }
];

export const PROVINCES = [
    "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", 
    "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape", "Other"
];